import { Head, Link, useForm } from '@inertiajs/react'
import { AuthShell, type ValuePanel } from '@/components/auth/AuthShell'
import { Button } from '@/components/ui/Button'
import { Field } from '@/components/ui/Field'

type Labels = {
  title: string
  tagline: string
  email_label: string
  password_label: string
  submit: string
  submit_processing: string
  forgot_password: string
  signup_prompt: string
  signup_cta: string
}

type Props = {
  labels: Labels
  value_panel: ValuePanel
}

export default function SessionNew({ labels, value_panel }: Props) {
  const { data, setData, post, processing, errors } = useForm({
    email_address: '',
    password: '',
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    post('/session')
  }

  return (
    <>
      <Head title={labels.title} />
      <AuthShell valuePanel={value_panel}>
        <h1 className="font-display text-3xl text-ink">{labels.title}</h1>

        <form onSubmit={handleSubmit} className="mt-6 space-y-5">
          <Field
            label={labels.email_label}
            name="email_address"
            type="email"
            value={data.email_address}
            onChange={(e) => setData('email_address', e.target.value)}
            required
            autoFocus
            error={errors.email_address}
          />
          <Field
            label={labels.password_label}
            name="password"
            type="password"
            value={data.password}
            onChange={(e) => setData('password', e.target.value)}
            required
            error={errors.password}
          />
          <Button type="submit" disabled={processing} className="w-full disabled:opacity-60">
            {processing ? labels.submit_processing : labels.submit}
          </Button>
        </form>

        <Link href="/passwords/new" className="mt-5 inline-block text-sm font-semibold text-ink-soft hover:text-ink">
          {labels.forgot_password}
        </Link>

        <p className="mt-6 text-sm text-ink-soft">
          {labels.signup_prompt}{' '}
          <Link href="/registration/new" className="font-bold text-flame hover:text-flame-deep">
            {labels.signup_cta}
          </Link>
        </p>
      </AuthShell>
    </>
  )
}
